import { z } from 'zod';
import { CarDamageElement } from '@/types/car/car-damage-element.type.ts';
import { CarDamageType } from '@/types/car/car-damage-type.type.ts';
import { CarDamagePhoto, CarDamagePhotoSchema } from '@/types/car/car-damage-photo.type.ts';

export type CarDamage = {
    id: number,
    element: CarDamageElement,
    type: CarDamageType,
    photo: CarDamagePhoto | null,
    paintwork_thickness: number | null,
    comment: string | null,
};

export const CarDamageSchema = z.object({
    id: z.number(),
    element: z.nativeEnum(CarDamageElement),
    type: z.nativeEnum(CarDamageType),
    photo: CarDamagePhotoSchema.nullable(),
    paintwork_thickness: z.number().nullable(),
    comment: z.string().nullable(),
});
